// removed by extract-text-webpack-plugin
module.exports = {"o-header":"_-PlntvqtOazrlZuFNCo4T","a-akzonobelLogo":"_31Vz4riDDkDNXhJ867Vzza","akzoHeader":"_39fmUrtpCHP0umKS0SlT46","flourishHeader":"_1qPjMx8GMos-qCPnXl9ln0","paintersHeader":"_3834XQuKwm_soFETM--uXy"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/Header/paintersStyle.scss
// module id = 956
// module chunks = 0